import { match } from "ts-pattern";
import { z } from "zod";
import { mapValues } from "../../../lib/functional";
import {
  SerializationSchema
} from "../../../serialization";
import { Group, GroupDefinition } from "../../group";
class Definition {
  static type = "makeswift::controls::shape-v2";
  static v1DataType = "shape-v2::v1";
  static Layout = {
    Inline: `${this.type}::layout::inline`,
    Popover: `${this.type}::layout::popover`
  };
  static deserialize(data, deserializeCallback) {
    if (data.type !== Definition.type)
      throw new Error(
        `ShapeV2: expected '${Definition.type}', got '${data.type}'`
      );
    const {
      config: { type, layout, ...config }
    } = z.object({
      type: z.literal(Definition.type),
      config: z.object({
        label: z.string().optional(),
        layout: z.union([
          z.literal(Definition.Layout.Inline),
          z.literal(Definition.Layout.Popover)
        ]).optional(),
        type: z.record(z.string(), SerializationSchema.deserializedRecord)
      })
    }).parse(data);
    const deserializedProps = mapValues(type, (itemDef) => {
      return deserializeCallback(itemDef);
    });
    return new GroupDefinition(
      {
        props: deserializedProps,
        preferredLayout: match(layout).with(Definition.Layout.Inline, () => Group.Layout.Inline).with(Definition.Layout.Popover, () => Group.Layout.Popover).otherwise(() => void 0),
        ...config
      },
      Definition.v1DataType
    );
  }
}
class ShapeV2Definition extends Definition {
}
export {
  ShapeV2Definition
};
//# sourceMappingURL=shape-v2.js.map